import styled from 'styled-components'
import { ButtonImageProps, ButtonProps, SectionBackgroundImageProps, InputProps } from '../../Context/types'

export const ButtonImage = styled.button<ButtonImageProps>`
    height: 100%;
    width: 100%;
    border: none;
    outline: none;
    background: url(${props => props.background});
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
`

export const InputText = styled.input<InputProps>`
border: 1px solid ${props => props.borderColor !== undefined && props.borderColor.length > 0 ? props.borderColor : 'var(--gray-normal)'};
padding: 0.8rem 1rem;
outline: none;
font-size: 1rem;
border-radius: 2rem;
color: var(--black-light);
`
export const LabelText = styled.label`
font-size: 1.1rem;
  font-weight: 500;
  color: var(--black-normal);
  position: absolute;
  top: -0.7rem;
  left: 1.5rem;
  background-color: var(--white-normal);
  padding: 0 0.5rem;
`


export const FormGroup = styled.div`
width: 100%;
  height: auto;

  display: flex;
  flex-direction: column;
  position: relative;
`

export const TextArea = styled.textarea<InputProps>`
border: 1px solid ${props => props.borderColor !== undefined && props.borderColor.length > 0 ? props.borderColor : 'var(--gray-normal)'};
padding: 1rem;
outline: none;
font-size: 1rem;
border-radius: 0.2rem;
resize: none;
width: 100%;
height: 15rem;
color: var(--black-light);

 &::-webkit-scrollbar{
  width: 7px;
  background: transparent;
}

&::-webkit-scrollbar-thumb{
  background-color: var(--black-light);
  border-radius: 2rem;
}
`

export const Button = styled.button<ButtonProps>`
${props => props.width ? `width:${props.width}rem;` : "width: 100%;"}
${props => props.height ? `height:${props.height}rem;` : "height: 100%;"}
${props => props.colorBorder ? `border: 1px solid ${props.colorBorder}` : `border: 1px solid var(--gray-normal);`}
${props => props.background ? `background-color:${props.background};` : "background: none;"}
${props => props.color ? `color:${props.color};` : "color: var(--black-light);"}
border-radius: 2rem;
text-align: center;
font-size: 1.2rem;
text-transform: uppercase;
font-weight: 600;
display: flex;
align-items: center;
justify-content: center;
transition: 0.3s;

&:hover{
  ${props => props.background ? `"background: none;"` : "  background-color: var(--blue-normal);"}
  border: none;
  ${props => !props.color && "color: var(--white-normal);"}
}

svg {
  margin-right: 0.3rem;
}
`

export const SectionBackgroundImage = styled.section<SectionBackgroundImageProps>`
  width: 100%;
  height: 100vh;
  ${props => props.background ? `
  background: url(${props.background.url});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;` : 'background: url(../../Assets/background.jpg);'}

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`
export const H2 = styled.h2<{
  color?: string
}>`
  text-align: center;
  font-size: 1.7rem;
  color: ${props => props.color ? props.color : 'var(--black-light)'};
  font-weight: 600;
  margin: 1rem auto;
  text-transform: uppercase;
`